import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from '../pages/login/LoginPage';
import { DashboardPage } from '../pages/dashboard/DashboardPage';
import { ItemsPage } from '../pages/items/ItemsPage';
import { CategoriesPage } from '../pages/categories/CategoriesPage';
import { SliderPage } from '../pages/slider/SliderPage';
import { AboutPage } from '../pages/about/AboutPage';
import { ContactMessagesPage } from '../pages/contact/ContactMessagesPage';
import { ContactSettingsPage } from '../pages/contact/ContactSettingsPage';
import { AdminLayout } from '../components/layout/AdminLayout';
import { isAuthenticated } from '../services/authService';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="items" element={<ItemsPage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="slider" element={<SliderPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="contact" element={<ContactMessagesPage />} />
        <Route path="contact-settings" element={<ContactSettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

